import type { ButtonHTMLAttributes, ComponentChildren } from 'preact';
import './Button.css';

export type ButtonVariant = 'green' | 'yellow' | 'blue' | 'purple' | 'pink' | 'red' | 'ghost';
export type ButtonSize = 'small' | 'normal' | 'big';

export interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'class' | 'size'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Stretch to the full width of the container. */
  block?: boolean;
  /** Emoji or small element shown before the label. */
  icon?: ComponentChildren;
  class?: string;
}

/** Chunky Geometry-Dash-style button. Defaults to type="button" (never submits by accident). */
export function Button({
  variant = 'blue',
  size = 'normal',
  block = false,
  icon,
  class: className,
  type = 'button',
  children,
  ...rest
}: ButtonProps) {
  const classes = ['btn', `btn--${variant}`, `btn--${size}`, block && 'btn--block', className]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} class={classes} {...rest}>
      {icon !== undefined && (
        <span class="btn__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      {children !== undefined && <span class="btn__label">{children}</span>}
    </button>
  );
}
